var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSe = function SvgSe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.23.02h16v12.8h-16V.02z",
    fill: "#004073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.23 19.2h16V32h-16V19.2z",
    fill: "#003F73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.23 12.81h16v6.4h-16v-6.4z",
    fill: "#FC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.704 0h6.4v32h-6.4V0z",
    fill: "#FC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 12.813h28.8v6.4H17.9v-6.4z",
    fill: "#FC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.098 19.2h28.8V32h-28.8V19.2zM18.098.02h28.8v12.8h-28.8V.02z",
    fill: "#003F73"
  })));
};
export default SvgSe;